module.exports = __webpack_public_path__ + "static/media/photo-1-sm.d20d7ee0.jpeg";